
import { Options, Vue, prop } from "vue-class-component";
import { PrintReceiptController } from "@/app/ui/controllers/PrintReceiptController";
import { SendInvoiceResponseData } from "@/domain/entities/PrintReceipt";

class Props {}

@Options({
  components: {}
})
export default class ModalSuccessSendInvoice extends Vue.with(Props) {
  get isShowModalSuccess() {
    return PrintReceiptController.isShowModalSuccess
  }
  set isShowModalSuccess(val: boolean) {
    PrintReceiptController.setIsShowModalSuccess(val)

    if(!val) {
      PrintReceiptController.setInvoiceSuccessData(new SendInvoiceResponseData())
    }
  }

  get successData() {
    return PrintReceiptController.invoiceSuccessData
  }

  get invoiceNo() {
    return this.successData?.invoiceNo || "";
  }

  get recipients() {
    return this.successData?.deliveries || [];
  }

  maskSensitiveData(contact: string, via: string): string {
    if (!contact) return "";

    if (via === "email") {
      // Mask email: l****n@gmail.com
      const [username, domain] = contact.split("@");
      if (username.length <= 2) {
        return `${username[0]}***@${domain}`;
      }
      const maskedUsername = `${username[0]}${"*".repeat(4)}${username[username.length - 1]}`;
      return `${maskedUsername}@${domain}`;
    } else {
      // Mask phone: 087***2738
      if (contact.length <= 6) {
        return contact;
      }
      const start = contact.substring(0, 3);
      const end = contact.substring(contact.length - 4);
      return `${start}***${end}`;
    }
  }

  formatVia(via: string): string {
    const viaMap: Record<string, string> = {
      email: "Email",
      whatsapp: "WhatsApp"
    };
    return viaMap[via] || via;
  }

  formatType(format: string): string {
    const formatMap: Record<string, string> = {
      "pdf_a4": "PDF (A4)",
      "png_a4": "PNG (A4)",
      "pdf_struk": "PDF (Ukuran Struk)"
    };
    return formatMap[format] || format;
  }

  onClose() {
    PrintReceiptController.setIsShowModalSuccess(false)
  }
}
